import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import state from './modules/state'
import service from './modules/service'
import me from './modules/me'
import accounts from './modules/accounts'
import registrationCards from './modules/registrationCards'
import activities from './modules/activities'
import activityReservations from './modules/activityReservations'
import cart from './modules/cart'
import transactions from './modules/transactions'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    state,
    service,
    me,
    accounts,
    registrationCards,
    activities,
    activityReservations,
    cart,
    transactions,
  },
})
